/**
 * Définitions des rôles de la console (permissions par ressource) —
 * copie de référence de la matrice du backend, utilisée par RBACContext
 * tant que le backend n'expose pas les permissions du compte courant
 * (décision S-6). Extrait de types/rbac.ts (déplacement pur).
 */
import {
  ResourceAction, RoleDefinition, UserRole, ROLE_DESCRIPTIONS, ROLE_LABELS, PermissionScope,
} from './rbac';

/**
 * Default role definitions (for reference)
 * These should be loaded from the backend
 */
export const DEFAULT_ROLE_DEFINITIONS: RoleDefinition[] = [
  {
    id: UserRole.SUPER_ADMIN,
    name: ROLE_LABELS[UserRole.SUPER_ADMIN],
    description: ROLE_DESCRIPTIONS[UserRole.SUPER_ADMIN],
    permissions: [
      {
        resource: '*',
        actions: [ResourceAction.ALL],
        scope: PermissionScope.GLOBAL
      }
    ],
    hierarchy: 4,
    canManageRoles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.LECTEUR]
  },
  {
    id: UserRole.ADMIN,
    name: ROLE_LABELS[UserRole.ADMIN],
    description: ROLE_DESCRIPTIONS[UserRole.ADMIN],
    permissions: [
      {
        resource: 'chapitres',
        actions: [ResourceAction.CREATE, ResourceAction.READ, ResourceAction.UPDATE, ResourceAction.DELETE],
        scope: PermissionScope.GLOBAL
      },
      {
        resource: 'lecons',
        actions: [ResourceAction.CREATE, ResourceAction.READ, ResourceAction.UPDATE, ResourceAction.DELETE],
        scope: PermissionScope.GLOBAL
      },
      {
        resource: 'exercices',
        actions: [ResourceAction.CREATE, ResourceAction.READ, ResourceAction.UPDATE, ResourceAction.DELETE],
        scope: PermissionScope.GLOBAL
      },
      {
        resource: 'users',
        actions: [ResourceAction.CREATE, ResourceAction.READ, ResourceAction.UPDATE],
        scope: PermissionScope.GLOBAL
      }
    ],
    hierarchy: 3,
    canManageRoles: [UserRole.LECTEUR]
  },
  {
    id: UserRole.LECTEUR,
    name: ROLE_LABELS[UserRole.LECTEUR],
    description: ROLE_DESCRIPTIONS[UserRole.LECTEUR],
    permissions: [
      {
        resource: 'chapitres',
        actions: [ResourceAction.READ],
        scope: PermissionScope.ASSIGNED_CLASSES
      },
      {
        resource: 'lecons',
        actions: [ResourceAction.READ],
        scope: PermissionScope.ASSIGNED_CLASSES
      },
      {
        resource: 'exercices',
        actions: [ResourceAction.READ],
        scope: PermissionScope.ASSIGNED_CLASSES
      }
    ],
    hierarchy: 1,
    canManageRoles: []
  }
];
